import { FC } from 'react';
import { LinkObject } from 'react-force-graph-2d';
import { Divider, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { Icon } from '@iconify/react';

interface LinkContentMenuProps {
  linkContext: { link: LinkObject; xy: [number, number] };
  onClose: () => void;
  onRemoveLinkClick: () => void;
}

/*
* title={`${linkContext?.link?.source?.id as string} \n → \n ${
            // @ts-ignore
            linkContext?.link?.target?.id as string
          }`}
* */

export const LinkContextMenu: FC<LinkContentMenuProps> = ({
  linkContext,
  onClose,
  onRemoveLinkClick,
}) => (
  <Menu
    open={Boolean(linkContext)}
    anchorReference={'anchorPosition'}
    anchorPosition={{
      top: linkContext.xy[1],
      left: linkContext.xy[0],
    }}
    onClose={onClose}
    PaperProps={{
      sx: {
        backgroundColor: 'rgba(8,12,30,0.97)',
        border: '1px solid rgba(99,102,241,0.3)',
        color: '#e5e7eb',
        '& .MuiMenuItem-root': {
          color: '#c5cae9',
          '&:hover': {
            backgroundColor: 'rgba(99,102,241,0.15)',
          },
        },
        '& .MuiDivider-root': {
          borderColor: 'rgba(99,102,241,0.2)',
        },
      },
    }}
  >
    <Stack direction={'row'} alignItems={'center'} spacing={1}>
      <Typography
        sx={{
          px: 2,
          fontWeight: 500,
          whiteSpace: 'pre-line',
          hyphens: 'auto',
          textAlign: 'center',
          pb: 0.5,
          maxWidth: 200,
          color: '#c5cae9',
          fontSize: 13,
        }}
      >
        {/* @ts-ignore */}
        {linkContext?.link?.source?.id as string}
      </Typography>
      <Icon icon="akar-icons:arrow-forward-thick-fill" color={'#6366f1'} />
      <Typography
        sx={{
          px: 2,
          fontWeight: 500,
          whiteSpace: 'pre-line',
          hyphens: 'auto',
          textAlign: 'center',
          pb: 0.5,
          maxWidth: 200,
          color: '#c5cae9',
          fontSize: 13,
        }}
      >
        {/* @ts-ignore */}
        {linkContext?.link?.target?.id as string}
      </Typography>
    </Stack>
    <Divider />
    <MenuItem
      onClick={onRemoveLinkClick}
      sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}
    >
      <Icon
        icon="clarity:remove-solid"
        style={{ marginRight: 8 }}
        color={'#ef4444'}
      />
      <>Remove Link</>
    </MenuItem>
  </Menu>
);
